import { EVENTS } from 'util.events'

// Keep an unassigned collection template preview selected while the native
// collection engine replaces filter parameters. Assigned templates need no view.
const previewKeys = ['view', 'preview_theme_id']

function preservePreviewParameters(event) {
  if (!event.target.closest?.('.bp-collection-main')) return

  const currentParams = new URLSearchParams(window.location.search)
  if (!previewKeys.some((key) => currentParams.has(key))) return

  const detail = event.detail
  const targetParams = detail instanceof FormData
    ? detail
    : detail?.formData instanceof FormData
      ? detail.formData
      : detail?.newUrl instanceof URL
        ? detail.newUrl.searchParams
        : null

  if (!targetParams) return

  previewKeys.forEach((key) => {
    const value = currentParams.get(key)
    if (value) targetParams.set(key, value)
  })
}

// Capture runs before ItemGrid's existing document bubble listeners, including
// native price sliders that send FormData directly rather than in detail.formData.
document.addEventListener(EVENTS.ajaxCollectionRender, preservePreviewParameters, true)
document.addEventListener('price-range:change', preservePreviewParameters, true)

// Pagination remains a normal crawlable link; preserve preview selection only
// when following it from this independent collection section.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('.bp-collection-main .element-pagination a')
  if (!link) return

  const currentParams = new URLSearchParams(window.location.search)
  if (!previewKeys.some((key) => currentParams.has(key))) return

  const targetUrl = new URL(link.href, window.location.origin)
  previewKeys.forEach((key) => {
    const value = currentParams.get(key)
    if (value) targetUrl.searchParams.set(key, value)
  })
  link.href = targetUrl.href
}, true)
